export default __webpack_public_path__ + "11a792560c8a92ea54c30ab81d4e2069.jpg";